import {
  RESET_CLIPBOARD,
  COPY_SELECTION,
  PASTE_SELECTION,
  SET_COPY,
  SET_COPY_DRIVES_ONLY,
  SET_COPY_PICKS_ONLY
} from "./constants.js";

import { EDIT_VALUES } from "../uptData/constants";
import { NEW_NOTIFICATION } from "../notifications/constants.js";
import selection from "../../../src/utils/nonReactiveState/selection.js";
import uptFile from "../../../src/utils/nonReactiveState/uptFile.js";
import clipboard from "../../../src/utils/nonReactiveState/clipboard.js";

const _ = require("lodash");

const regex = /^(clipboard\/)/;

const _RESET_CLIPBOARD = RESET_CLIPBOARD.replace(regex, "");
const _COPY_SELECTION = COPY_SELECTION.replace(regex, "");
const _PASTE_SELECTION = PASTE_SELECTION.replace(regex, "");

export default {
  [_COPY_SELECTION]({ commit, rootState, dispatch }) {
    if (rootState.selection.isSelectionPicksOnly) {
      const pickIndexes = _.sortBy(
        _.uniq(selection.selectionList.map(s => s[0]))
      );
      const pickValues = [];
      pickIndexes.forEach(p => {
        pickValues.push([...uptFile.pickData.driveData.data[p]]);
      });
      const relativePickIndexes = pickIndexes.map(p => p - pickIndexes[0]);
      commit(SET_COPY_PICKS_ONLY, {
        pickIndexes: relativePickIndexes,
        pickValues
      });
    } else if (rootState.selection.isSelectionDrivesOnly) {
      const driveIndexes = _.sortBy(
        _.uniq(selection.selectionList.map(s => s[1]))
      );
      const driveValues = [];
      driveIndexes.forEach(d => {
        driveValues.push([
          ..._.flatten(uptFile.pickData.driveData.data.map(p => p[d]))
        ]);
      });
      const driveTypes = driveIndexes.map(
        d => uptFile.pickData.driveData.tagNames[d]
      );
      const relativeDriveIndexes = driveIndexes.map(p => p - driveIndexes[0]);
      commit(SET_COPY_DRIVES_ONLY, {
        driveIndexes: relativeDriveIndexes,
        driveValues,
        driveTypes
      });
    } else {
      const sortedIndexes = _.sortBy(selection.selectionList);
      const values = [];
      sortedIndexes.forEach(i => {
        values.push(uptFile.pickData.driveData.data[i[0]][i[1]]);
      });
      const pickIndexes = sortedIndexes.map(i => i[0]);
      const minPickIndex = _.min(pickIndexes);
      const pickRange = _.max(pickIndexes) - minPickIndex + 1;
      const driveIndexes = sortedIndexes.map(i => i[1]);
      const minDriveIndex = _.min(driveIndexes);
      const driveRange = _.max(driveIndexes) - minDriveIndex + 1;
      const relativeSortedIndexes = sortedIndexes.map(i => [
        i[0] - minPickIndex,
        i[1] - minDriveIndex
      ]);
      const driveTypes = _.sortBy(_.uniq(driveIndexes)).map(d => {
        return {
          index: d,
          type: uptFile.pickData.driveData.tagNames[d]
        };
      });
      const startDrive = driveTypes[0].index;
      const relativeDriveTypes = driveTypes.map(d => {
        d.index = d.index - startDrive;
        return d;
      });
      commit(SET_COPY, {
        indexes: relativeSortedIndexes,
        values,
        rangeX: driveRange,
        rangeY: pickRange,
        driveTypes: relativeDriveTypes
      });
    }
    selection.resetSelection();
    dispatch(
      NEW_NOTIFICATION,
      {
        message: "Values copied.",
        priority: "success"
      },
      { root: true }
    );
  },

  [_PASTE_SELECTION]({ dispatch }) {
    if (clipboard.isPasteDisabled()) {
      dispatch(
        NEW_NOTIFICATION,
        {
          message: "The selected values can not be pasted.",
          priority: "warning"
        },
        { root: true }
      );
      return;
    }

    const indexes = [];
    const values = [];
    const firstSelection = _.head(selection.selectionList);
    const selectionLength = selection.selectionList.length;

    switch (clipboard.type) {
      case "picks":
        if (selection.selectionList.length === 1) {
          const startIndex = selection.selectionList[0][0];
          clipboard.indexes.forEach(pickIndex => {
            indexes.push(
              ...clipboard.values[pickIndex].map((v, i) => {
                return [pickIndex + startIndex, i];
              })
            );
            values.push(...clipboard.values[pickIndex]);
          });
        } else {
          indexes.push(
            ..._.orderBy(selection.selectionList, ["1", "0"], ["asc", "asc"])
          );
          values.push(..._.flatten(clipboard.values));
        }
        break;
      case "drives":
        if (selection.selectionList.length === 1) {
          const startDrive = selection.selectionList[0][1];
          clipboard.indexes.forEach(driveIndex => {
            indexes.push(
              ...clipboard.values[driveIndex].map((v, i) => {
                return [i, driveIndex + startDrive];
              })
            );
            values.push(...clipboard.values[driveIndex]);
          });
        } else {
          indexes.push(
            ..._.orderBy(selection.selectionList, ["1", "0"], ["asc", "asc"])
          );
          values.push(..._.flatten(clipboard.values));
        }
        break;
      case "undefined":
        if (selectionLength === 1) {
          clipboard.indexes.forEach(i => {
            indexes.push([firstSelection[0] + i[0], firstSelection[1] + i[1]]);
          });
          values.push(...clipboard.values);
        } else {
          indexes.push(..._.sortBy(selection.selectionList));
          values.push(...clipboard.values);
        }
        break;
      default:
        dispatch(
          NEW_NOTIFICATION,
          {
            message: "The copied values are invalid and can not be pasted.",
            priority: "warning"
          },
          { root: true }
        );
        return;
    }
    dispatch(
      EDIT_VALUES,
      {
        values: values,
        selections: indexes
      },
      { root: true }
    );
    selection.resetSelection();
    dispatch(_RESET_CLIPBOARD);
  },
  [_RESET_CLIPBOARD]({ commit }) {
    commit(RESET_CLIPBOARD);
  }
};
